// extracted by mini-css-extract-plugin
module.exports = {"Compact":"Compact_Compact__1Rfif"};